import React from "react"
import { formattedNumber } from "../../../utils"
import { Link } from "gatsby"

const CommonImpact = ({ data }) => {
  return (
    <section
      style={{
        backgroundImage: `url('${data.backgroundImage}')`,
        backgroundSize: "cover",

        backgroundRepeat: "no-repeat",
        backgroundPosition: "left 85% center",
        backgroundOrigin: "border-box",
      }}
      className="px-10 md:px-20 h-full md:pe-20 flex  pt-12 md:pt-[2.75rem] md:gap-20 xl:gap-24"
    >
      <div className="items-stretch  w-max md:min-w-[650px] xl:min-w-[1000px]  basis-full flex justify-center md:gap-12 xl:gap-24 md:flex-col">
        <div className="flex flex-grow justify-between items-center  md:gap-24 xl:gap-40">
          <div
            className={`flex justify-end md:mt-16 xl:mt-20 self-start  flex-col gap-6 items-start `}
          >
            <div className="flex flex-col w-[390px] md:w-[420px] xl:w-[496px]  gap-4">
              <div className="flex items-center gap-2">
                <div className="bg-blue-100 w-2 h-2 rounded-full"></div>
                <h4
                  className={`text-gray-300 text-lg lg:text-2xl tracking-[-0.56px] md:tracking-tight-4% `}
                >
                  Result
                </h4>
              </div>
              <h2
                className={`text-white-200  text-3xl md:text-7xl lg:text-8xl tracking-[-.96px] md:tracking-tight-2% lg:tracking-tight-7%`}
              >
                {data.label}
              </h2>
              <p
                className={`text-[1.08rem] md:text-[1.125rem] mt-0 md:mt-6 xl:mt-8  text-primary-100 `}
              >
                {data.description}
              </p>
            </div>
            <div className="flex flex-col md:mt-6 xl:mt-8  md:gap-6 xl:gap-8">
              <div className="flex flex-wrap md:flex-nowrap w-[390px] md:w-max justify-start gap-4 md:gap-8 lg:gap-16 lg:max-w-[70%]">
                {data.stats.map(stat => (
                  <div
                    className="flex min-w-[149px] md:min-w-[auto] flex-col gap-2 md:gap-4"
                    key={stat.heading}
                  >
                    {typeof stat.heading === "number" ? (
                      <h3 className="flex font-oxygen items-start text-white-100  md:-tracking-[4.2px] -tracking-[2.24px] text-[2.5rem] md:text-6xl">
                        {formattedNumber(stat.heading)}
                        <div className=" ms-1 text-[2.5rem] md:text-6xl">+</div>
                      </h3>
                    ) : (
                      <p className=" whitespace-nowrap text-white-100  md:-tracking-[4.2px] -tracking-[2.24px] text-[2.5rem] md:text-6xl">
                        {stat.heading}
                      </p>
                    )}
                    <p className="text-base -tracking-[0.32px] text-nowrap text-primary-100">
                      {stat.subheading}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="min-w-[434px] md:min-w-[700px] xl:min-w-[1000px] flex flex-col justify-center items-end">
            <div className="flex w-[70%] md:w-[70%] xl:w-[70%] flex-col items-center gap-8 md:gap-6 xl:gap-8">
              <div className=" text-[1.85rem] md:text-6xl text-white-200 text-center">
                Want your product to create a similar impact?
              </div>
              <div className="">
                <Link
                  to="/contactus"
                  className="border inline-block transition-all border-white-200 hover:border-transparent hover:bg-blue-100 text-white-200 hover:text-white-200  rounded-full text-xl tracking-tight-2%  font-normal py-2 md:py-4 px-5 md:px-16 h-[48px] md:h-16 "
                >
                  <span className="flex items-center justify-center h-full">
                    Get in Touch
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CommonImpact
